<template>
    <div id="content">
        <div class="container">
            <div class="row">
                <div class="col-md-3" v-for="(photo, i) in items" :key="i">
                    <processed-photo :item="photo"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ProcessedPhoto from '../components/ProcessedPhoto';

  export default {
    components: {
      ProcessedPhoto,
    },
    data() {
      return {
        items: [
          {
            large_photo: 'https://agontuk.github.io/assets/images/berserk.jpg',
            medium_photo: 'https://agontuk.github.io/assets/images/berserk.jpg',
            processing: null,
            /*processing: {
              data: {
                x: 574.7491856677525,
                y: 139.30944625407184,
                width: 657.9283387622147,
                height: 370.0846905537458,
                rotate: 0,
                scaleX: 1,
                scaleY: 1,
              },
              cropBoxData: {
                left: 204.33333333333334,
                top: 67.71875,
                width: 175.33333333333331,
                height: 98.625,
              },
            },*/
          },
          {
            large_photo: 'https://agontuk.github.io/assets/images/berserk.jpg',
            medium_photo: 'https://agontuk.github.io/assets/images/berserk.jpg',
            processing: {
              data: {
                x: 696.4951140065144,
                y: 782.6188925081433,
                width: 498.6579804560259,
                height: 280.4951140065146,
                rotate: 0,
                scaleX: -1,
                scaleY: 1,
              },
              cropBoxData: {
                left: 236.77777777777771,
                top: 239.15625,
                width: 132.88888888888889,
                height: 74.75,
              },
            },
          },
        ],
      };
    },
  };
</script>
